// @flow
import type {Action} from '../../../state/types'

export type SearchByLocationPayload = {
  city: Url,
  district: ?Url,
}

const id = 'map/SEARCH_BY_LOCATION'

export const searchByLocation = (city: Url, district: ?Url): Action<SearchByLocationPayload> => ({
  type: id,
  payload: {
    city,
    district,
  }
})

searchByLocation.id = id
